import { useMemo } from 'react';
import { CustomerSearchNotAvailableError } from 'components/content/error/CustomerSearchNotAvailableError';
import { NoContractFoundError } from 'components/content/error/NoContractFoundError';
import { RateLimitExceededError } from 'components/content/error/RateLimitExceededError';
import { ServiceNotAvailableError } from 'components/content/error/ServiceNotAvailableError';
import { CustomerSourceNotSupportedError } from 'components/content/error/CustomerSourceNotSupportedError';
import { ClientError } from '@cobra/fe-lib/client-error-handling/classes/ClientError';
import {
    CrmtServiceUnavailableErrorResult,
    InstallationAddressInvalidErrorResult,
    InvalidParametersErrorResult,
    NoContractFoundErrorResult,
    RateLimitExceededErrorResult,
    UnsupportedCustomerSourceErrorResult,
} from '@cobra/fe-lib/client-error-handling/classes/ErrorResult';

export const useDisplayErrorForCustomerSearch = (
    error:
        | ClientError<
              | NoContractFoundErrorResult
              | RateLimitExceededErrorResult
              | CrmtServiceUnavailableErrorResult
              | InstallationAddressInvalidErrorResult
              | InvalidParametersErrorResult
              | UnsupportedCustomerSourceErrorResult
          >
        | undefined,
    skipPath: string
) =>
    useMemo(() => {
        if (!error) {
            return null;
        }
        switch (error.title) {
            case 'NO_CONTRACT_FOUND':
                return <NoContractFoundError />;
            case 'RATE_LIMIT_EXCEEDED':
                return <RateLimitExceededError />;
            case 'INSTALLATION_ADDRESS_INVALID':
            case 'CRMT_SERVICE_UNAVAILABLE':
                return <CustomerSearchNotAvailableError skipPath={skipPath} />;
            case 'UNSUPPORTED_CUSTOMER_SOURCE':
                return <CustomerSourceNotSupportedError />;
            case 'INVALID_PARAMETER':
            default:
                return <ServiceNotAvailableError />;
        }
    }, [error, skipPath]);
